import * as api from 'service/ErplyAPI/addresses';
import { EMPLOYEE_ID } from 'utils/constants';
import { addError } from 'rdx/alert';

import * as types from './types';

// TODO: Check first in redux state for address and if it doesn't exist try fetching then

export const fetchAddresses = (queryParams) => async (dispatch) => {
  dispatch({ type: types.FETCH_ADDRESS.START });
  try {
    const data = await api.getAddresses(queryParams);
    if (data.records.length) {
      const [payload] = data.records;
      dispatch({ type: types.FETCH_ADDRESS.SUCCESS, payload });
    }
  } catch (err) {
    dispatch({ type: types.FETCH_ADDRESS.ERROR, payload: err.message });
  }
};

export const fetchCurrentEmployeeAddress = () => async (dispatch) => {
  const ownerID = localStorage.getItem(EMPLOYEE_ID);
  dispatch(fetchAddresses({ ownerID }));
};

export const saveAddress = (address) => async (dispatch) => {
  dispatch({ type: types.SAVE_ADDRESS.START });
  try {
    await api.saveAddress(address);
    dispatch({ type: types.SAVE_ADDRESS.SUCCESS, payload: address });
  } catch (err) {
    dispatch(addError(err.message));
    dispatch({ type: types.SAVE_ADDRESS.ERROR, payload: err.message });
  }
};

export const fetchAddressTypes = (lang) => async (dispatch) => {
  dispatch({ type: types.FETCH_ADDRESS_TYPES.START });
  try {
    const payload = await api.getAddressTypes({ lang });
    dispatch({
      type: types.FETCH_ADDRESS_TYPES.SUCCESS,
      payload: payload.records,
    });
  } catch (err) {
    dispatch(addError(err.message));
    dispatch({ type: types.FETCH_ADDRESS.ERROR, payload: err.message });
  }
};
